import UtilArray from "@/utils/UtilArray.mjs";

export const ADMIN_OWNER_USER_ID = "23e308ed-4f67-4394-9a77-7228d2992dc3";

const resolveId = (value = null) => {
    if (value && typeof value === "object") {
        return value.id || value._id || value.userId || "";
    }
    return value || "";
};

const hasOwn = (obj = {}, key = "") => Object.prototype.hasOwnProperty.call(obj || {}, key);

const normalizeOwners = (owners = []) => {
    if (!Array.isArray(owners)) return [];
    return owners.map((item) => String(resolveId(item) || "").trim()).filter(Boolean);
};

export const buildOwnersWithAdmin = ({ loggedUserId = "", owners = [], owner = null, ownerId = null } = {}) => {
    const logged = String(resolveId(loggedUserId) || "").trim();
    const ownerSingle = String(resolveId(owner) || "").trim();
    const ownerSingleId = String(resolveId(ownerId) || "").trim();

    return UtilArray.unique([
        ADMIN_OWNER_USER_ID,
        logged,
        ownerSingle,
        ownerSingleId,
        ...normalizeOwners(owners),
    ].filter(Boolean));
};

export const applyOwnersRule = (payload = {}, loggedUserId = "") => {
    const source = payload && typeof payload === "object" ? payload : {};
    const hasOwnerField = hasOwn(source, "owner") || hasOwn(source, "ownerId") || hasOwn(source, "owners");

    if (!hasOwnerField) {
        return source;
    }

    const owners = buildOwnersWithAdmin({
        loggedUserId,
        owners: source.owners,
        owner: source.owner,
        ownerId: source.ownerId,
    });

    const logged = String(resolveId(loggedUserId) || "").trim();

    const next = {
        ...source,
        owners,
    };

    if (hasOwn(source, "owner") && !resolveId(source.owner) && logged) {
        next.owner = logged;
    }

    if (hasOwn(source, "ownerId") && !resolveId(source.ownerId) && logged) {
        next.ownerId = logged;
    }

    return next;
};
